import React, { useState, useEffect, useRef } from 'react';
import { 
  Home,
  BookOpen, 
  Code, 
  Award,
  Github,
  Linkedin,
  Mail,
  Menu,
  X,
  ExternalLink
} from 'lucide-react';
import './styles.css';
import moto1 from './IMG_0042.PNG';
import moto2 from './IMG_0044.PNG';
import social from './IMG_0047.PNG'; // adjust the path based on your folder
import donkey from './IMG_0051.PNG';
import immers from './IMG_0050.JPG';

const personalInfo = {
  name: "ALBIN JOY",
  title: "Web Developer",
  email: "albinjoy52@gmail.com",
  github: "https://github.com",
  linkedin: "https://www.linkedin.com/in/albin-joy-110b6b351?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
};

const titles = ["Mern Stack Developer", "Filmmaker", "Associate Unity Developer"];

const about = [
  {
  about1: "I am a passionate MERN stack developer who enjoys building dynamic, scalable web applications. Using React, Node.js, Express, and MongoDB, I craft responsive, efficient, and modern solutions.",
  about2: "In addition to development, I'm also interested in exploring new technologies and continuously expanding my knowledge in the software development industry.",
  about3:"I am also a passionate video editor with a creative mindset. I have strong skills in editing footage, adding various VFX, and crafting immersive sound design. Video editing allows me to blend technical precision with artistic storytelling, which I truly enjoy."
  }
]

const education = [
  {
    id: 1,
    degree: "Bachelor of Computer Science and Design",
    institution: "Viswajyothi College Of Engineering and Technology",
    year: "2021 - 2025",
    cgpa: "75%",
    description: "Graduated with distinction, specializing in web technologies and software development."
  },
  {
    id: 2,
    degree: "Higher Secondary Education",
    institution: "St. Sebastians HSS Anicadu",
    year: "2019 - 2021",
    cgpa: "95%",
    description: "Science stream with Computer Science as elective."
  },
  {
    id: 3,
    degree: "High School Education",
    institution: "St. Sebastians HSS Anicadu",
    year: "2016 - 2019",
    cgpa: "98%",
    description: "Completed with excellent academic record."
  }
];

const SkillsSection = ({ skillsRef }) => {
  const webDevSkills = [
    { name: 'React Js', icon: '⚛️', color: '#61DAFB' },
    { name: 'HTML', icon: '🌐', color: '#E34F26' },
    { name: 'CSS', icon: '🎨', color: '#1572B6' },
    { name: 'JavaScript', icon: 'JS', color: '#F7DF1E' },
    { name: 'Node Js', icon: '🟢', color: '#339933' },
    { name: 'Express Js', icon: 'ex', color: '#000000' },
    { name: 'MongoDB', icon: '🍃', color: '#47A248' },
    { name: 'VS Code', icon: 'VSC', color: '#007ACC' },
  ];

  const animationSkills = [
    { name: 'Premiere Pro', icon: 'Pr', color: '#9999FF' },
    { name: 'After Effects', icon: 'Ae', color: '#9999FF' },
    { name: 'Blender', icon: '🔺', color: '#F5792A' },
    { name: 'Capcut', icon: 'cc', color: '#00000' },
    { name: 'Davinci Resolve', icon: 'DR', color: '#F5792A' },
    { name: 'Photoshop', icon: 'Ps', color: '#31A8FF' },
    // { name: 'Unreal Engine', icon: 'UE', color: '#313131' },
    { name: 'Unity 3D', icon: 'U3D', color: '#000000' },
    { name: 'GitHub', icon: '🐙', color: '#181717' },
    
    // { name: 'Postman', icon: '📮', color: '#FF6C37' }
  ];
  const SkillItem = ({ skill }) => (
    <div className="skill-item">
      <div className="skill-icon" style={{ color: skill.color }}>
        {skill.icon}
      </div>
      <span className="skill-name">{skill.name}</span>
    </div>
  );

  return (
    <section 
      id="skills-section" 
      ref={skillsRef} 
      className="section section-container skills-section"
    >
      <div className="skills-container">
        <h1 className="skills-title">SKILLS</h1>
        <div className="title-underline"></div>
        
        <div className="skills-grid">
          {/* WebDev Category */}
          <div className="skill-category">
            <div className="category-header">
              <h3 className="category-title">Web Development</h3>
            </div>
            <div className="skills-wrapper">
              <div className="skills-icon-grid">
                {webDevSkills.map((skill, index) => (
                  <SkillItem key={index} skill={skill} />
                ))}
              </div>
            </div>
          </div>

          {/* Animation and Others Category */}
          <div className="skill-category">
            <div className="category-header">
              <h3 className="category-title">Editing & Others</h3>
            </div>
            <div className="skills-wrapper">
              <div className="skills-icon-grid">
                {animationSkills.map((skill, index) => (
                  <SkillItem key={index} skill={skill} />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};


const projects = [
  {
  id: 1,
  title: "Social Media Platform",
  image: social,
  technologies: ["React", "Node.js", "Supabse", "Express"],
  description: "A social media application for initiatives and communities with user authentication, where users can register, post, and engage in a collaborative space.",
  link: "https://github.com//ecommerce"
},

  {
    id: 2,
    title: "Mototorque",
    image: moto1,
    technologies: ["Premiere Pro", "After Effects", "Blender"],
    description: "A 3D animated promotional content designed and developed for a college auto show, featuring creative editing, color grading, and sound mixing for an engaging visual experience.",
    link: "https://www.instagram.com/reel/Cp7_VWwsIpk/?igsh=NnZicHcya2Z5ZG5t"
  },
  {
    id: 3,
    title: "Mototorque 2.0",
    technologies: ["Premiere Pro", "After Effects", "Blender"],
    image: moto2,
    description: "An updated 3D animation promotional content for the college auto show, featuring refined visuals, smoother animation, and enhanced sound design..",
    link: "https://www.instagram.com/reel/C3xgNtePLnW/?igsh=emxkeTllNmJkbGtk"
    
  },
  {
    id: 4,
    title: "Immerscape VR",
    image: immers,
    technologies: ["Blender", "Unity 3D","C#"],
    description: "An interactive virtual reality environment designed and developed with high immersion and user interactivity, fully created from scratch.",
    link: "https://drive.google.com/drive/folders/1-9vICc39h5X3Pxo2QQErvnWktrqHX30p"
  },
  {
    id: 5,
    title: "DonkeyKong Game",
    image: donkey,
    technologies: ["Unity 3D", "C#"],
    description: "An arcade game inspired by the classic Donkey Kong, designed and developed from scratch with multiple levels and enhanced gameplay.",
    link: "https://drive.google.com/drive/folders/1-GAH7kDeCWB2hhZP9OlfxS2Pd_GGZsYN"
  },
  {
    id: 6,
    title: "Chat Application",
    image: "https://via.placeholder.com/150",
    technologies: ["React", "Socket.io", "Node.js"],
    description: "A real-time chat application with private messaging and group chat functionality.",
    link: "https://github.com//chat-app"
  }
];

function App() {
  const [activeSection, setActiveSection] = useState("home");
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [currentTitleIndex, setCurrentTitleIndex] = useState(0);
  const [isHidden, setIsHidden] = useState(false);

  const homeRef = useRef(null);
  const educationRef = useRef(null);
  const aboutRef = useRef(null);
  const skillsRef = useRef(null);
  const experienceRef = useRef(null);
  const projectsRef = useRef(null);

  useEffect(() => {
    const sectionRefs = {
      home: homeRef,
       about:aboutRef,
      education: educationRef,
      skills: skillsRef,
      experience: experienceRef,
      projects: projectsRef
    };

    const observerOptions = {
      root: null,
      rootMargin: "-50% 0px",
      threshold: 0
    };

    const handleIntersect = (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const sectionId = entry.target.id.replace('-section', '');
          setActiveSection(sectionId);
        }
      });
    };

    const observer = new IntersectionObserver(handleIntersect, observerOptions);
    Object.values(sectionRefs).forEach(ref => {
      if (ref.current) observer.observe(ref.current);
    });

    return () => {
      Object.values(sectionRefs).forEach(ref => {
        if (ref.current) observer.unobserve(ref.current);
      });
    };
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsHidden(true);
      setTimeout(() => {
        setCurrentTitleIndex((prev) => (prev + 1) % titles.length);
        setIsHidden(false);
      }, 500);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

  const navigateTo = (section) => {
    setActiveSection(section);
    setSidebarOpen(false);

    const sectionRefs = {
      home: homeRef,
      about:aboutRef,
      education: educationRef,
      skills: skillsRef,
      experience: experienceRef,
      projects: projectsRef
    };

    if (sectionRefs[section] && sectionRefs[section].current) {
      sectionRefs[section].current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <div className="app-container">
      <header className="header">
        <div className="header-container">
          <div className="logo-container">
            <button className="menu-toggle" onClick={toggleSidebar}><Menu size={24} /></button>
            <h2 className="logo">{personalInfo.name}</h2>
          </div>
          <nav className="desktop-nav">
            {["home","about", "education", "skills",  "projects"].map(section => (
              <button
                key={section}
                onClick={() => navigateTo(section)}
                className={activeSection === section ? "active" : ""}
              >
                {section.charAt(0).toUpperCase() + section.slice(1)}
              </button>
            ))}
          </nav>
          <div className="social-icons">
            {/* <a href={personalInfo.github} target="_blank" rel="noopener noreferrer"><Github size={20} /></a> */}
            <a href={personalInfo.linkedin} target="_blank" rel="noopener noreferrer"><Linkedin size={20} /></a>
            <a href={`mailto:${personalInfo.email}`}><Mail size={20} /></a>
          </div>
        </div>
      </header>

      <aside className={`sidebar ${sidebarOpen ? 'open' : ''}`}>
        <button className="sidebar-close" onClick={toggleSidebar}><X size={24} /></button>
        <nav className="sidebar-nav">
          <ul>
            {[{ id: 'home', icon: <Home size={20} /> }, { id: 'education', icon: <BookOpen size={20} /> }, { id: 'skills', icon: <Code size={20} /> },  { id: 'projects', icon: <Award size={20} /> }].map(({ id, icon }) => (
              <li key={id}>
                <button onClick={() => navigateTo(id)} className={activeSection === id ? "active" : ""}>{icon}<span>{id.charAt(0).toUpperCase() + id.slice(1)}</span></button>
              </li>
            ))}
          </ul>
        </nav>
        <div className="sidebar-social">
          <div className="sidebar-social-icons">
            
            <a href={personalInfo.github} target="_blank" rel="noopener noreferrer"><Github size={20} /></a>
            <a href={personalInfo.linkedin} target="_blank" rel="noopener noreferrer"><Linkedin size={20} /></a>
            
            <a href={`mailto:${personalInfo.email}`}><Mail size={20} /></a>
          </div>
        </div>
      </aside>

      <main className="main-content">
        <section id="home-section" ref={homeRef} className="home-section section-container">
          <div className="background-overlay"></div>
          <div className="home-content">
            <div className="greeting-text">Hello, I am</div>
            <h1 className="home-title">{personalInfo.name}</h1>
            <h5 className={`home-subtitle ${isHidden ? 'hidden' : ''}`}>{titles[currentTitleIndex]}</h5>
            <p className="home-description">{personalInfo.about1}</p>
            <p className="home-description">{personalInfo.about2}</p>
            <div className="cta-buttons">
              <a href="https://drive.google.com/file/d/1O3mpdDgPZbzvWYdPG58wIOh3XFEdhdJJ/view?usp=drivesdk" target="_blank" rel="noopener noreferrer">
  <button className="cta-button">RESUME</button>
</a>

              <button className="cta-button2" onClick={() => navigateTo("projects")}>MY WORK</button>
            </div>
            <div className="social-links">
              <a href={personalInfo.github} target="_blank" rel="noopener noreferrer" className="social-link"><Github size={24} /></a>
              <a href={personalInfo.linkedin} target="_blank" rel="noopener noreferrer" className="social-link"><Linkedin size={24} /></a>
              <a href="https://www.instagram.com/_albwn?igsh=enp1ZGs0ZGVhMHYz&utm_source=qr" target="_blank" rel="noopener noreferrer" className="social-link">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line></svg>
              </a>
            </div>
          </div>
        </section>

        <section id="about" ref={aboutRef} className="section section-container">
  <h1 className="section-title">About Me</h1>
  <div className="about-list">
    {about.map((item, index) => (
      <div key={index} className="card">
        <p className="card-description">{item.about1}</p>
        <p className="card-description">{item.about2}</p>
        <p className="card-description">{item.about3}</p>
      </div>
    ))}
  </div>
</section>


        {/* education */}

        <section id="education-section" ref={educationRef} className="section section-container">
          <h1 className="section-title">Education</h1>
          <div className="education-list">
            {education.map(edu => (
              <div key={edu.id} className="card">
                <h3 className="card-title">{edu.degree}</h3>
                <h4 className="card-subtitle">{edu.institution}</h4>
                <p className="card-period">{edu.year}</p>
                <p className="card-period">Percentage: {edu.cgpa}</p>
                <p className="card-description">{edu.description}</p>
              </div>
            ))}
          </div>
        </section>

        <SkillsSection skillsRef={skillsRef} />

        

        <section id="projects-section" ref={projectsRef} className="section section-container">
  <h1 className="section-title">Projects</h1>
  <div className="projects-grid">
    {projects.map(project => (
      <div key={project.id} className="project-card">
        
        {/* 🖼️ Image added here */}
        {project.image && (
          <img
            src={project.image}
            alt={project.title}
            className="project-image"
          />
        )}
        
        <h3 className="project-title">{project.title}</h3>
        <div className="tech-tags">
          {project.technologies.map((tech, index) => (
            <span key={index} className="tech-tag">{tech}</span>
          ))}
        </div>
        <p className="project-description">{project.description}</p>
        <a href={project.link} target="_blank" rel="noopener noreferrer" className="project-link">
          View Project <ExternalLink size={16} />
        </a>
      </div>
    ))}
  </div>
</section>

      </main>
    </div>
  );
}

export default App;